import axios from "axios";
import store from "../store/store";
import errorhandling from "../js/errorhandling";

//Base URL is set based on the environment in main.js//
let baseUrl = "";
const methodTypes = { post: "post", get: "get", put: "put" };

const Environments = {
  local: "https://localhost:44387/api/",
  dev:
    "https://txadltsapi-dev.txschedulingappserviceenvironment.p.azurewebsites.us/api/",
  qa:
    "https://txadltsapi-qa.txschedulingappserviceenvironment.p.azurewebsites.us/api/",
  preview:
    "https://txadltsapi-preview.txschedulingappserviceenvironment.p.azurewebsites.us/api/",
  stage: "https://txadltsapi-stage.azurewebsites.us/api/",
  production: "https://adltsapi.txdpsscheduler.com/api/",
};

function getServiceUrl(env) {
  let url = Environments.production;
  switch (env) {
    case "local":
      url = Environments.local;
      break;
    case "dev":
      url = Environments.dev;
      break;
    case "qa":
      url = Environments.qa;
      break;
    case "preview":
      url = Environments.preview;
      break;
    default:
      url = Environments.production;
  }
  return url;
}

async function callService(serviceApi, params, method) {
  try {
    let response = await axios({
      method: method,
      url: serviceApi,
      data: params,
    });
    return response;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      throw error;
    } else {
      handleError(error);
    }
  }
}

async function callServiceSecure(serviceApi, params, method) {
  const userSession = store.getters["userSession"];
  const token = userSession.authToken.token;
  console.log(userSession);
  try {
    let response = await axios({
      method: method,
      url: serviceApi,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: params,
    });
    return response;
  } catch (error) {
    console.log(error);
    if (error.response) {
      const response = error.response;
      const tokenExpired = error.response.headers["token-expired"];

      if (response.status === 401 && tokenExpired) {
        //Display a message and return tos start page//
        const sasToken = userSession.authToken.sasToken;
        const refreshToken = userSession.authToken.refreshToken;
        const refreshTokeResponse = await callService(
          "Authenticate/Refresh",
          {
            token: token,
            sasToken: sasToken,
            refreshToken: refreshToken,
          },
          methodTypes.post
        );
        store.dispatch("setAuthToken", refreshTokeResponse.data);
        return await callServiceSecure(serviceApi, params, method);
      } else {
        handleError(error);
      }
    } else {
      handleError(error);
    }
  }
}

function handleError(error) {
  console.log(error);
  errorhandling.showErrorMessage(error, true, true);
}

function callServiceSecure1(serviceApi, params, method) {
  baseUrl = store.getters["baseApiUrl"];
  const url = `${baseUrl}${serviceApi}`;
  const userSession = store.getters["userSession"];
  const token = userSession.authToken.token;
  console.log(userSession);
  return axios({
    method: method,
    url: url,
    headers: {
      Authorization: "Bearer " + token,
    },
    data: params,
  })
    .then((response) => {
      console.log(response.headers);
      return response;
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error.response);
      console.log(error.response.headers);
      console.log(document.cookie);
      const tokenExpired = error.response.headers["token-expired"];
      if (error.response.status == 401 && tokenExpired) {
        const refreshToken = userSession.authToken.refreshToken;
        try {
          callService(
            "Authenticate/Refresh",
            {
              token: token,
              refreshToken: refreshToken,
            },
            methodTypes.post
          ).then((response) => {
            //set new auth token data//
            console.log(response.data);
            store.dispatch("setAuthToken", response.data);
            return callServiceSecure(serviceApi, params, method);
          });
        } catch (error) {
          console.log(error);
          throw "Unable to refresh token";
        }
      } else {
        throw error;
      }
    });
}

export default {
  callService,
  callServiceSecure,
  callServiceSecure1,
  baseUrl,
  methodTypes,
  Environments,
  getServiceUrl,
};
